import React from 'react';
import PropTypes from 'prop-types';

const Text = ({ 
    children,
    header = null,
    variant = "primary",
    size = "paragraph",
    mono = false,
    bold = false,
    classes = "",
    style = {},
    ...props 
}) => {
    const classString = `text ${mono ? "anonymous-pro" : "figtree"}${bold ? "-bold" : ""} ${variant} ${size} ${classes}`;
    if (header === 1) {
        return (
            <h1 className={classString} style={style} {...props}>
                {children}
            </h1>
        );
    } else if (header === 2) {
        return (
            <h2 className={classString} style={style} {...props}>
                {children}
            </h2>
        );
    } else if (header === 3) {
        return (
            <h3 className={classString} style={style} {...props}>
                {children}
            </h3>
        );
    } else if (header === 4) {
        return (
            <h4 className={classString} style={style} {...props}>
                {children}
            </h4>
        );
    } else if (header === 5) {
        return (
            <h5 className={classString} style={style} {...props}>
                {children}
            </h5>
        );
    } else if (header === 6) {
        return (
            <h6 className={classString} style={style} {...props}>
                {children}
            </h6>
        );
    } else {
        return (
            <p className={classString} style={style} {...props}>
                {children}
            </p>
        )
    }
};

Text.propTypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'positive', 'white', 'warning']),
    header: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    size: PropTypes.oneOf(['paragraph', 'title', 'caption', 'micro', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
    mono: PropTypes.bool,
    bold: PropTypes.bool,
    classes: PropTypes.string,
    style: PropTypes.object,
};

export default Text;